import React, { useState } from 'react'
import { Grid } from '@mui/material'
import {
  InLineLighterHeading,
  ProfileComponentsContainer,
  SectionHeading,
  SectionSubHeading,
  StrongHeading,
} from '../MentorProfilePageStyles'
import PictureUploadComponent from 'src/consumer/components/Helpers/PictureUploadComponent/PictureUploadComponent'

export function YourImagesSection({
  formState,
  setFormState,
  setPage,
  handleChange,
  handleNestedChange,
}) {
  return (
    <>
      <ProfileComponentsContainer container spacing={4}>
        <Grid item paddingBottom={'10px'} xs={12}>
          <SectionHeading>Interface Images</SectionHeading>
          <SectionSubHeading>
            These are the images that will be used for your content.
          </SectionSubHeading>
        </Grid>
        <Grid item display={'flex'} flexDirection={'column'} gap="5px" xs={12}>
          <div className="d-flex justify-content-between align-items-center pr-2">
            <div>
              <StrongHeading>
                Hero Image <InLineLighterHeading>(Recommended: 1200 x 1500)</InLineLighterHeading>
              </StrongHeading>
              <SectionSubHeading>This is a Hero Image</SectionSubHeading>
            </div>
            <PictureUploadComponent
              id="heroCardImage"
              value={formState?.heroCardImage}
              onChange={handleChange}
              aspectWidth={1200}
              aspectHeight={1500}
            />
          </div>
        </Grid>
        <Grid item display={'flex'} flexDirection={'column'} gap="5px" xs={12}>
          <div className="d-flex justify-content-between align-items-center pr-2">
            <div>
              <StrongHeading>
                Blog Banner <InLineLighterHeading>(Recommended: 2240 x 1260)</InLineLighterHeading>
              </StrongHeading>
              <SectionSubHeading>
                This is the image that will be the banner that will be seen by the community
              </SectionSubHeading>
            </div>
            <PictureUploadComponent
              id="blogBanner"
              value={formState?.blogBanner}
              onChange={handleChange}
              aspectWidth={2240}
              aspectHeight={1260}
            />
          </div>
        </Grid>
        <Grid item display={'flex'} flexDirection={'column'} gap="5px" xs={12}>
          <div className="d-flex justify-content-between align-items-center pr-2">
            <div>
              <StrongHeading>
                Cover Image <InLineLighterHeading>(Recommended: 720 x 410)</InLineLighterHeading>
              </StrongHeading>
              <SectionSubHeading>
                This is the image that will be the background of your content.
              </SectionSubHeading>
            </div>
            <PictureUploadComponent
              id="coverImage"
              value={formState?.coverImage}
              onChange={handleChange}
              aspectWidth={720}
              aspectHeight={410}
            />
          </div>
        </Grid>
        <Grid item display={'flex'} flexDirection={'column'} gap="5px" xs={12}>
          <div className="d-flex justify-content-between align-items-center pr-2">
            <div>
              <StrongHeading>
                Backdrop <InLineLighterHeading>(Recommended: 900 x 1600)</InLineLighterHeading>
              </StrongHeading>
              <SectionSubHeading>This is a backdrop image</SectionSubHeading>
            </div>
            <PictureUploadComponent
              id="backdropImage"
              value={formState?.backdropImage}
              onChange={handleChange}
              aspectWidth={900}
              aspectHeight={1600}
            />
          </div>
        </Grid>
      </ProfileComponentsContainer>
    </>
  )
}
